export const environment = {
  production: false,
  version: "2.1.1",

  // firebase: {
  //   apiKey: "AIzaSyCoFPB7IdcBqlYRQv1Vbrsiuid3ithjBMs",
  //   authDomain: "goldhubberdev.firebaseapp.com",
  //   databaseURL: "https://goldhubberdev.firebaseio.com",
  //   storageBucket: "gs://goldhubberdev.appspot.com",
  //   messagingSenderId: "103953800507",
  // },
  // stripeKey: "pk_test_8xyzJwV5BJXSrs2hHK6bnmVb",
  // connectStripe: "ca_DDoCYpdgb0zAHWjwo1oF9ZlQ4qVXKrPw",
  // committeeUrl: "http://applanche.com/golfhubber-club-committee/#/login",
  // baseUrl: "https://sandbox-cm.zest.golf",
  // userName: "golfhubber",
  // password: "golfhubber123456",
  // stripeUrl: "http://60.254.111.219//golfhubber-matchplay/#/components/bank",
  // userCheckUrl: 'https://us-central1-goldhubberdev.cloudfunctions.net/getUserDetailByEmail',
  
  crypto_key: 'ccC2H21lDDbQDfakxcrtXXQdd0FloLGG',
  magazine_image_height: '215px',
  magazine_image_width: '335px',
  
  firebase: {
    apiKey: "AIzaSyBYLbM2piUY6tNZSeJkxirZi0Q2Nj7Hl4o",
    authDomain: "golfhubberprod.firebaseapp.com",
    databaseURL: "https://golfhubberprod.firebaseio.com",
    storageBucket: "gs://golfhubberprod.appspot.com",
    messagingSenderId: "103953800507",
  },
  stripeKey: "pk_live_WybIGRxXVCtikfht1xltl1uk  ",
  connectStripe: "ca_DDoCQaGr8pvCscKPcOvug1baSUCgvL9a",
  committeeUrl: "https://golfhubber.com/committee/#/login",
  baseUrl: "https://cm.zest.golf",
  userName: "info@golfhubber.com",
  password: "holein1hubber",
  stripeUrl: "https://golfhubberportal.com/components/bank",
  userCheckUrl: 'https://us-central1-golfhubberprod.cloudfunctions.net/getUserDetailByEmail',
};
